import React, { useState, useEffect } from 'react'
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import dayjs from 'dayjs';
import {
  Modal,
  Table,
  Tag,
  Button,
  Popconfirm,
  Input,
  Dropdown,
  Menu,
  Avatar,
  Divider
} from 'antd';
import {
  assignOrgAtom,
  reloadLeadsAtom,
  notificationsAtom,
  userPrivilagesAtom
} from '../../../../atoms/Atoms';
import api from '../../../../api/api';
import { toFormattedLocalTime } from '../../../../functions';

function LeadAssignOrganizationModal() {
  const userPrivilages = useRecoilValue(userPrivilagesAtom);
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [lead, setLead] = useRecoilState(assignOrgAtom);
  const [loading, setLoading] = useState(false);
  const [organizations, setOrganizations] = useState([]);
  const [notifications, setNotifications] = useRecoilState(notificationsAtom);
  const setReloadLeads = useSetRecoilState(reloadLeadsAtom);

  function getOrganizations() {
    setLoading(true);
    api.get('organizations/active')
      .then((response) => {
        setLoading(false);
        if (response?.data?.success) {
          setOrganizations(response.data.data);
        } else {
          setNotifications([
            ...notifications,
            {
              title: t('error'),
              description: response?.data?.error,
              error: true,
            }
          ]);
        }
      })
      .catch((error) => {
        setLoading(false);
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: error.message,
            error: true,
          }
        ]);
      })
  }

  function assign(orgId) {
    setLoading(true);
    api
      .post('leads/assign/org', { OrganizationId: orgId, LeadId: lead?.id })
      .then((response) => {
        setLoading(false);
        if (response?.data?.success) {
          setNotifications([
            ...notifications,
            {
              title: t('success'),
              description: response.data.message,
              error: false,
            },
          ]);
          setLead(null);
          setReloadLeads(true);
        } else {
          setNotifications([
            ...notifications,
            {
              title: t('error'),
              description: response?.data?.error,
              error: true,
            },
          ]);
        }
      })
      .catch((error) => {
        setLoading(false);
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: error.message,
            error: true,
          },
        ]);
      });
  }

  useEffect(() => {
    if (lead) {
      setOpen(true);
      getOrganizations();
    } else {
      setOpen(false);
    }
  }, [lead]);

  return (
    <Modal
      title={t('assign_organization')}
      width="80%"
      open={open}
      onCancel={() => {
        setLead(null);
      }}
      footer={[]}
    >
      <div className="mt-6">
        <Divider orientation="left">
          {t('assigned_to')}
        </Divider>
        {lead?.referredBy && (
          <span className="italic text-gray-400">{lead?.referredBy.nameEn}</span>
        )}
        {!lead?.referredBy && (
          <span className="italic text-gray-400">N/A</span>  
        )}
        <Divider />
        <Table
          locale={{
            emptyText: t('no_data')
          }}
          className="mt-4"
          dataSource={organizations}
          bordered
          loading={loading}
          rowKey="id"
          pagination={false}
          columns={[
            {
              title: t('name'),
              align: 'left',
              className: 'text-sm',
              render: (row) => (
                <span>{row.nameEn}</span>
              ),
            },
            {
              title: t('referral_code'),
              align: 'left',
              className: 'text-sm',
              render: (row) => (
                <span>{row.referralCode}</span>
              ),
            },
            {
              title: '',
              align: 'center',
              className: 'text-sm',
              render: (row) => (
                <div className="space-x-2">
                  <Popconfirm
                    title={t('assign_organization_prompt')}
                    okText={t('yes')}
                    cancelText={t('no')}
                    onConfirm={() => assign(row.id)}
                  >
                  <Button
                    size="small"
                    type="primary"
                  >
                    {t('assign')}
                  </Button>
                  </Popconfirm>
                </div>
              ),
            }
          ]}
        />
      </div>
    </Modal>
  );
}

export default LeadAssignOrganizationModal;
